import type { AbilityBuilder } from '@casl/ability'
import type { AppAbility } from '~/types/authorization.type'
import type { User } from '~/types/user.type'
import { userRoles } from '../roles'

export function defineDashboardAbilities(abilityBuilder: AbilityBuilder<AppAbility>, user: User) {
  const { can } = abilityBuilder

  can('read', 'dashboard')

  const roles = userRoles(user)

  if (roles.administrator || roles.client_lead)
    can('read', 'dashboard-admin-metrics')
}
